var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _class2, _descriptor4, _dec5, _dec6, _class3, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../ModelTraits";
import LatLonHeightTraits from "./LatLonHeightTraits";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import DiscretelyTimeVaryingTraits from "./DiscretelyTimeVaryingTraits";
import SplitterTraits from "./SplitterTraits";
export let TileCoordinates = (_dec = primitiveTrait({
  type: "number",
  name: "x",
  description: "X coordinate of the tile"
}), _dec2 = primitiveTrait({
  type: "number",
  name: "y",
  description: "Y coordinate of the tile"
}), _dec3 = primitiveTrait({
  type: "number",
  name: "level",
  description: "Zoom level of the tile"
}), _class = class TileCoordinates extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "x", _descriptor, this);
    _initializerDefineProperty(this, "y", _descriptor2, this);
    _initializerDefineProperty(this, "level", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "x", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "y", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "level", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let TimeFilterCoordinates = (_dec4 = objectTrait({
  name: "Tile coordinates",
  type: TileCoordinates,
  description: "x, y, level coordinates of the picked tile. Refer: https://cesium.com/docs/cesiumjs-ref-doc/ImageryProvider.html?classFilter=imageryprovider#pickFeatures"
}), _class2 = class TimeFilterCoordinates extends mixTraits(LatLonHeightTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "tile", _descriptor4, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "tile", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let TimeFilterTraits = (_dec5 = primitiveTrait({
  type: "string",
  name: "Time filter property",
  description: "The name of a property in a feature returned from this layer's feature query service that indicates the times at which this layer covers this position. For example, historical and near-real-time satellite imagery often comes as daily swaths, with a given area on the globe potentially only covered every number of days."
}), _dec6 = objectTrait({
  type: TimeFilterCoordinates,
  name: "Time filter coordinates",
  description: "The current position picked by the user for filtering"
}), _class3 = class TimeFilterTraits extends mixTraits(DiscretelyTimeVaryingTraits, SplitterTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "timeFilterPropertyName", _descriptor5, this);
    _initializerDefineProperty(this, "timeFilterCoordinates", _descriptor6, this);
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "timeFilterPropertyName", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "timeFilterCoordinates", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export { TimeFilterTraits as default };